import React from 'react';

import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { get } from 'lodash';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { NOT_IMAGE_PROPERTY, ROOMS_UNAVAILABLE_ERROR } from '@constants';

import { isVacationRentalsFromPath, renderNumber } from '@share/utils';
import { RootState } from '@share/utils';
import { IHotelDetailsState, IReviewBookState, IRoomsSearchState } from '@store/slices';
import { Currency } from '@components';
import { NoImageSvg } from '@assets';
import { ILoginState } from '@share/store/slices';

import './style.scss';

interface IMapStateToProps {
  reviewBookStore: IReviewBookState;
  hotelDetailsStore: IHotelDetailsState;
  roomsSearchStore: IRoomsSearchState;
  loginStore: ILoginState;
}

interface IProps extends IMapStateToProps, RouteComponentProps {}

const ZERO = 0;

class RoomImageComponent extends React.Component<IProps> {

  hasNotRealImageProperty = (): boolean => {
    const titleImage = this.props.reviewBookStore.bookingSummary?.bookingCard?.titleImage;
    return !!(titleImage && titleImage?.toLowerCase().includes(NOT_IMAGE_PROPERTY));
  };

  render(): React.ReactNode {
    const { roomsSearchStore, reviewBookStore, hotelDetailsStore, loginStore, history } = this.props
    const { bookingComplete, bookingSummary, error, expiredSession } = reviewBookStore;
    const { account } = loginStore;

    const isRoomUnavaliableError = error === ROOMS_UNAVAILABLE_ERROR;
    const isExpiredSession = expiredSession;
    const displayScreenOnError = isRoomUnavaliableError || isExpiredSession;

    const roomsTitle = bookingSummary?.bookingCard?.roomsTitle;
    const titleImage = displayScreenOnError ? hotelDetailsStore.hotel?.hotelDetails?.thumb : bookingSummary?.bookingCard?.titleImage;
   
    const hotel = roomsSearchStore.hotel ? roomsSearchStore.hotel : hotelDetailsStore.hotel;
  
    const pricePerNight = bookingSummary?.bookingCard.package.pricePerNight;

    const packageId = bookingSummary?.bookingCard.package.packageId;
    const currency = bookingSummary?.bookingCard.package.currency;
    
    const disableSavingsTagVacationRentals = account?.disableSavingsTagVacationRentals;

    const isVacationRentals = isVacationRentalsFromPath(history);

    const adjustedPackageGroups = hotel?.adjustedPackageGroups;
    const groupPackages = adjustedPackageGroups?.map(({ groupedPackages }) => get(groupedPackages, `[0]`, null)).filter(p => !!p);
    const cheapestRoom = adjustedPackageGroups?.length ? groupPackages?.reduce((prev: any, current: any) => (+current?.pricePerNight >= +prev?.pricePerNight)? prev :  current) : null;
    const preferredRoomSavingsAmount = get(cheapestRoom, `savings`, 0);
    const preferredRoomPrice = get(cheapestRoom, `price`, 1);
    const preferredRoomPackageId = get(cheapestRoom, `packageId`, null);
    const preferredRoomSavingPctInt = preferredRoomSavingsAmount / (preferredRoomPrice + preferredRoomSavingsAmount) * 100;
    const preferredRoomSavingPctIntDecimals = preferredRoomSavingPctInt - Math.floor(preferredRoomSavingPctInt);
    const preferredRoomSavingPct = preferredRoomSavingPctIntDecimals >= 0.5 ? Math.ceil(preferredRoomSavingPctInt) : preferredRoomSavingPctInt;

    const isPreferredRoomPackageId = preferredRoomPackageId === packageId;

    const shouldShowSavingsTag = !displayScreenOnError && (!account?.isSaverRuleProfits && preferredRoomSavingPct && preferredRoomSavingPct > 0 && (!isVacationRentals || !disableSavingsTagVacationRentals) && (isPreferredRoomPackageId || !account?.isSundance));

    const notRealImageProperty = this.hasNotRealImageProperty();
    const styleImg: any = {};
    if (notRealImageProperty) {
      styleImg.filter = 'grayscale(100%)';
    }

    return (
      <div className="room-image">

        <div className="room-image__wrapper">
          {bookingComplete && (
            <div className="room-image__label-info">
              <p className="room-image__label-text-per-night">
                <FormattedMessage id="avg.rate" />
              </p>
              <p className="room-image__label-price"><Currency currency={currency} />{renderNumber(pricePerNight)}</p>
              <p className="room-image__label-text-per-night">
                <FormattedMessage id="per.night" />
              </p>
            </div>)}

          {shouldShowSavingsTag ? (
            <div className={`room-image__room-preferred-savings ${isPreferredRoomPackageId? 'preferred' : 'non-preferred' }`}>
              <div className="hotel-card-wrapper__label-container">
                <div className="hotel-card-wrapper__label">
                  <p className="hotel-card-wrapper__label-title">
                    <FormattedMessage id={account?.forceMemberWording ? 'member.save' : 'save'} /> {Math.floor(preferredRoomSavingPct).toFixed(0)} %
                  </p>
                </div>
                <div className="hotel-card-wrapper__label-corner"></div>
              </div>
            </div>) : null}

          {notRealImageProperty && (
            <div style={{ position: 'absolute', top: '0', right: '0', bottom: '0', left: '0', background: 'rgba(0, 0, 0, 0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 200 }}>
              <p className="condo-hotel-card__label-title" style={{ color: 'white', fontSize: '12px' }}>
                <FormattedMessage
                  id="not.real.image.property"
                  defaultMessage="Not actual photo of the property"
                />
              </p>
            </div>)}

          {titleImage &&titleImage?.length !== ZERO ? (
            <div className={`room-image__room-image`}>
              {isPreferredRoomPackageId && (<div className={`room-image__room-preferred`}>Popular room</div>)}
              <img className="room-image__room-img" src={titleImage} alt={roomsTitle} style={styleImg} />
            </div>
          ) : (
            <div className="room-image__room-img no-image">
              <NoImageSvg />
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: RootState): IMapStateToProps => {
  return {
    reviewBookStore: state.reviewBookStore,
    roomsSearchStore: state.roomsSearchStore,
    hotelDetailsStore: state.hotelDetailsStore,
    loginStore: state.loginStore,
  };
};

export const RoomImage = connect(mapStateToProps)(withRouter(RoomImageComponent));

